import { withMessageFn } from 'atpjs/validation/functions'
import { regexp, reportError } from 'atpjs/validation/validators'

export const phone = (errorMessage) => {
  return withMessageFn(
    regexp(/^([+]\d{1,3}|00\d{1,3}|0)(\s?)([0-9]{1,3})(\s?)(\d{1,3}|)(\s?)(\d{1,3})(\s?)(\d{1,3})$/),
    (value) => reportError({ value }, errorMessage)
  )
}
